// extracted by mini-css-extract-plugin
export var instantResultCategory = "search-module--instantResultCategory--464a4";
export var instantResults = "search-module--instantResults--6849d";
export var instantSearchNoResults = "search-module--instantSearchNoResults--c5f14";
export var link = "search-module--link--26940";
export var noResultsWrapper = "search-module--noResultsWrapper--e959f";
export var snippet = "search-module--snippet--8d866";
export var tabResults = "search-module--tabResults--67abf";
export var viewAllWrapper = "search-module--viewAllWrapper--1ebfb";